import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Select, { SelectOption } from '@amzn/meridian/select';
import Tab, { TabGroup } from '@amzn/meridian/tab';
import Toggle from '@amzn/meridian/toggle';
import { setJmrFilter, setT2Mode } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppSelector } from 'src/store/store';
import { isT2Admin, isUsingT2Experience, JmrJobTypes } from 'src/utils/jmrUtils';

interface TopOptionsProps {
  searchField?: string;
  setSearchField?: (val: string) => void;
  scrollToJob?: (jobId: string) => void;
}
const TopOptions = ({ searchField, setSearchField, scrollToJob }: TopOptionsProps) => {
  const dispatch = useDispatch();
  const { jmrFilter, backgroundFormData, t2AdminToggle, jmrResults } = useAppSelector((state) => state.newJmrPage);
  const { featureFlags, ldap } = useAppSelector((state) => state.user);

  const selectedOptions = jmrResults.filter((r) => r.isChecked);
  const isUsingT2 = isUsingT2Experience(featureFlags, ldap, backgroundFormData.jobLevel, t2AdminToggle);

  const getT2OverrideToggleDisplayState = () => {
    if (t2AdminToggle !== null) {
      return t2AdminToggle;
    }
    return +(backgroundFormData?.jobLevel || '') > 1;
  };

  return (
    <Column width="100%" spacing={'0'}>
      <Row spacingInset={'400 0 0 0'} backgroundColor="white">
        {!isUsingT2 && (
          <TabGroup value={jmrFilter.jobType} onChange={(jobType) => dispatch(setJmrFilter({ ...jmrFilter, jobType }))}>
            <Tab value={JmrJobTypes.ProcessPath} aria-label="Process Path" data-cy="new-jmr__results__process-path-btn">
              Process Path
            </Tab>
            <Tab value={JmrJobTypes.TLD} aria-label="TLD" data-cy="new-jmr__results__tld-btn">
              TLD
            </Tab>
          </TabGroup>
        )}
      </Row>

      <Row
        width="100%"
        widths={!isUsingT2 ? ['fill', 'fit', 'fit'] : ['fit']}
        alignmentHorizontal={isUsingT2 ? 'end' : 'justify'}
        spacingInset={'400 0'}
        alignmentVertical="center"
        backgroundColor="white"
      >
        {!isUsingT2 && (
          <Row>
            {!!setSearchField && (
              <SearchField
                value={searchField}
                aria-label="Search"
                onChange={setSearchField}
                placeholder="Search for..."
                onSubmit={() => {}}
              />
            )}

            {scrollToJob && (
              <Select
                disabled={!selectedOptions.length}
                placeholder={`${selectedOptions.length || 'None'} Selected`}
                onChange={(id: string) => scrollToJob(id)}
              >
                {selectedOptions.map((row) => (
                  <SelectOption label={row.name} value={row.id} key={row.id} />
                ))}
              </Select>
            )}
          </Row>
        )}

        {isT2Admin(ldap) && featureFlags.T2_PLUS_EXPERIENCE && (
          <Toggle
            checked={getT2OverrideToggleDisplayState()}
            onChange={() => dispatch(setT2Mode(!getT2OverrideToggleDisplayState()))}
            aria-label="T2+ Experience Toggle"
          >
            T2+ Experience
          </Toggle>
        )}
      </Row>
    </Column>
  );
};

export default TopOptions;
